const getterTypes = {
    GET_ADDRESS: 'GET_ADDRESS',
};

export { getterTypes };
